module.exports = __webpack_public_path__ + "static/media/a4.44bbd87.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/songyimin/a4.mp3
// module id = i8Pf
// module chunks = 0